<template>
	<div class="page account">
		<section id="navigation">
			<div class="container">
				<div class="content flex">
					<svg class="navigation-icon left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22"><path d="M5.5,5.5A5.5,5.5,0,1,1,11,11,5.5,5.5,0,0,1,5.5,5.5ZM0,22V19.25c0-3,5-5.5,11-5.5s11,2.48,11,5.5V22Z"/></svg>
					<span class="navigation-title">{{$t('account')}}</span>
				</div>
			</div>
		</section>
		<transition name="slide-up" mode="out-in" appear>
			<section class="main">
				<div class="container">
					<div class="content">
						<p id="welcome">{{$t('welcome-back')}}&nbsp;{{username}}</p>
					</div>
				</div>
				<hr>
				<div class="container">
					<div class="content">
						<div class="cards" data-cols="4">
							<div class="card">
								<h3 class="card-title">
									<svg class="card-title-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M16 11c1.66 0 3-1.34 3-3s-1.33-3-3-3-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 3-1.34 3-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0a11.68 11.68 0 0 0-.97.05C16.2 13.9 17 15.02 17 16.5V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/></svg>
									{{$t('customers')}}
								</h3>
								<router-link :to="{name: 'customers'}" class="button">{{$t('view')}}</router-link>
							</div>
							<div class="card">
								<h3 class="card-title">
									<svg class="card-title-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z"/></svg>
									{{$t('machines')}}
								</h3>
								<router-link :to="{name: 'machines'}" class="button">{{$t('view')}}</router-link>
							</div>
							<div class="card">
								<h3 class="card-title">
									<svg class="card-title-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M4 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 1 0 0-3zm0-6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 1 0 0-3zm0 12c-.83 0-1.5.68-1.5 1.5A1.51 1.51 0 0 0 4 19.5 1.51 1.51 0 0 0 5.5 18c0-.82-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"/></svg>
									{{$t('machine-types')}}
								</h3>
								<router-link :to="{name: 'machine-types'}" class="button">{{$t('view')}}</router-link>
							</div>
							<div class="card">
								<h3 class="card-title">
									<svg class="card-title-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14 2H6c-1.1 0-2 .9-2 2V20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/></svg>
									{{$t('documents')}}
								</h3>
								<router-link :to="{name: 'documents'}" class="button">{{$t('view')}}</router-link>
							</div>
						</div>
					</div>
				</div>
				<hr>
				<div class="container">
					<div class="content">
						<button @click="logout">{{$t('exit')}}</button>
					</div>
				</div>
			</section>
		</transition>
	</div>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'Home',
	data() {
		return {
		}
	},
	computed: {
		username() {
			return this.$store.getters.getProfile.name;
		}
	},
	methods: {
		logout() {
			let self = this;
			this.$store.dispatch('authLogout')
			.then(() => {
				self.$router.push({name: 'login'});
			});
		}
	}
}
</script>

<style scoped>
#welcome {
	margin-bottom: 0;
	padding: 1.6rem 0;
	font-size: 2.4rem;
}
</style>